export default __webpack_public_path__ + "static/spinner-f2b8df1b0b4f7dd53d9c644ee5a0ba08.webp";